import {
  type ExtractDocumentTypeFromTypedRxJsonSchema,
  type RxCollection,
  type RxJsonSchema,
  toTypedRxJsonSchema,
} from "rxdb";
import { useRxCollection, type useRxData } from "rxdb-hooks";
import { SYNCABLE_META } from "./common";

export const RXDB_CLINICAL_PRODUCT_FORM_COLLECTION_NAME =
  "clinical-product-form";

export const useRxCollectionClinicalProductForm =
  (): RxCollection<ClinicalProductForm> | null =>
    useRxCollection<ClinicalProductForm>(
      RXDB_CLINICAL_PRODUCT_FORM_COLLECTION_NAME,
    );

type UseRxData = Parameters<typeof useRxData<ClinicalProductForm>>;
export type ClinicalProductFormQueryConstructor = UseRxData["1"];

const CLINICAL_PRODUCT_FORM_SCHEMA_LITERAL = {
  title: "clinical product form schema",
  version: 1,
  description: "Represents a Clinical Product Form",
  type: "object",
  primaryKey: "id",
  properties: {
    id: {
      type: "string",
      maxLength: 100,
    },
    meta: SYNCABLE_META,
    title: {
      type: "object",
      properties: {
        en: { type: "string" },
        es: { type: ["string", "null"] },
        fr: { type: ["string", "null"] },
      },
      required: ["en", "es", "fr"],
    },
    keywords: {
      type: "array",
      items: {
        type: "string",
      },
    },
    snomedId: {
      type: ["string", "null"],
    },
  },
  required: ["id", "meta", "title", "keywords", "snomedId"],
  /*
   * It is important to set 'as const' to preserve the literal type.
   *
   * biome-ignore lint/suspicious/noExplicitAny: We infer the DB type from this
   * object, the satisfies just provides us type inference for this object.
   */
} as const satisfies RxJsonSchema<any>;

const schemaTyped = toTypedRxJsonSchema(CLINICAL_PRODUCT_FORM_SCHEMA_LITERAL);

export type ClinicalProductForm = ExtractDocumentTypeFromTypedRxJsonSchema<
  typeof schemaTyped
>;

export const CLINICAL_PRODUCT_FORM_SCHEMA: RxJsonSchema<ClinicalProductForm> =
  CLINICAL_PRODUCT_FORM_SCHEMA_LITERAL;
